var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBadgeBetaTester = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100%",
  viewBox: "0 0 680 680",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "outerP",
  x1: 0.2,
  y1: 0,
  x2: 0.8,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#C9A0E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "30%",
  stopColor: "#9B6AB8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "70%",
  stopColor: "#6E3A8E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#4A1E68"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "midP",
  x1: 0.2,
  y1: 0,
  x2: 0.8,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#B488D0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "35%",
  stopColor: "#7E48A8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "65%",
  stopColor: "#5C2E82"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3E1860"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "innerP",
  x1: 0.15,
  y1: 0,
  x2: 0.85,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#8E58B2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "40%",
  stopColor: "#6A3494"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3A1660"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "flaskBody",
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFFFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E8DCF0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "liquidG",
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E8DCF0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#D0C0E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "glossTop",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFFFFF",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFFFFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "outerClip"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 295
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "innerClip"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 228
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "flaskClip"
}, /*#__PURE__*/React.createElement("path", {
  d: "M298,230 L298,340 L222,480 Q218,492 228,500 L452,500 Q462,492 458,480 L382,340 L382,230 Z"
})))), /*#__PURE__*/React.createElement("circle", {
  cx: 344,
  cy: 346,
  r: 298,
  fill: "#1E0830",
  opacity: 0.45,
  style: {
    fill: "rgb(30, 8, 48)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.45,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 298,
  fill: "url(#outerP)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 298,
  fill: "none",
  stroke: "#D4B0E8",
  strokeWidth: 3,
  opacity: 0.35,
  style: {
    fill: "none",
    stroke: "rgb(212, 176, 232)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 3,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.35,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 275,
  fill: "none",
  stroke: "#3A1660",
  strokeWidth: 3,
  opacity: 0.5,
  style: {
    fill: "none",
    stroke: "rgb(58, 22, 96)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 3,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 268,
  fill: "url(#midP)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 268,
  fill: "none",
  stroke: "#9B6AB8",
  strokeWidth: 1.5,
  opacity: 0.3,
  style: {
    fill: "none",
    stroke: "rgb(155, 106, 184)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "1.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.3,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 240,
  fill: "none",
  stroke: "#2E1050",
  strokeWidth: 3.5,
  style: {
    fill: "none",
    stroke: "rgb(46, 16, 80)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "3.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 237,
  fill: "none",
  stroke: "#B488D0",
  strokeWidth: 1,
  opacity: 0.25,
  style: {
    fill: "none",
    stroke: "rgb(180, 136, 208)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.25,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 232,
  fill: "url(#innerP)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#innerClip)",
  opacity: 0.06,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.06,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("rect", {
  x: 110,
  y: 110,
  width: 460,
  height: 460,
  fill: "none",
  style: {
    fill: "none",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 140,
  y1: 100,
  x2: 140,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 162,
  y1: 100,
  x2: 162,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 184,
  y1: 100,
  x2: 184,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 206,
  y1: 100,
  x2: 206,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 228,
  y1: 100,
  x2: 228,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 250,
  y1: 100,
  x2: 250,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 272,
  y1: 100,
  x2: 272,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 294,
  y1: 100,
  x2: 294,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 316,
  y1: 100,
  x2: 316,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 338,
  y1: 100,
  x2: 338,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 360,
  y1: 100,
  x2: 360,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 382,
  y1: 100,
  x2: 382,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 404,
  y1: 100,
  x2: 404,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 426,
  y1: 100,
  x2: 426,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 448,
  y1: 100,
  x2: 448,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 470,
  y1: 100,
  x2: 470,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 492,
  y1: 100,
  x2: 492,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 514,
  y1: 100,
  x2: 514,
  y2: 580,
  stroke: "#1E0830",
  strokeWidth: 6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(30, 8, 48)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(340,360) scale(1.15) translate(-340,-360)",
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M298,228 L298,338 L218,486 Q212,500 228,510 L452,510 Q468,500 462,486 L382,338 L382,228 Z",
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 14,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  opacity: 0.9,
  style: {
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M298,230 L298,340 L222,482 Q218,494 230,502 L450,502 Q462,494 458,482 L382,340 L382,230 Z",
  fill: "url(#flaskBody)",
  stroke: "none",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 282,
  y: 218,
  width: 116,
  height: 16,
  rx: 6,
  fill: "#FFFFFF",
  stroke: "none",
  style: {
    fill: "rgb(255, 255, 255)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 282,
  y: 218,
  width: 116,
  height: 16,
  rx: 6,
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 3,
  opacity: 0.9,
  style: {
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 3,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.9,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#flaskClip)",
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("rect", {
  x: 218,
  y: 400,
  width: 244,
  height: 110,
  fill: "url(#liquidG)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M222,400 Q280,388 340,400 Q400,412 458,400",
  fill: "none",
  stroke: "#C8AAE0",
  strokeWidth: 2,
  opacity: 0.5,
  style: {
    fill: "none",
    stroke: "rgb(200, 170, 224)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("circle", {
  cx: 290,
  cy: 460,
  r: 16,
  fill: "#5C2E82",
  opacity: 0.6,
  style: {
    fill: "rgb(92, 46, 130)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.6,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 348,
  cy: 448,
  r: 14,
  fill: "#5C2E82",
  opacity: 0.55,
  style: {
    fill: "rgb(92, 46, 130)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.55,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 400,
  cy: 466,
  r: 12,
  fill: "#5C2E82",
  opacity: 0.5,
  style: {
    fill: "rgb(92, 46, 130)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 320,
  cy: 484,
  r: 10,
  fill: "#5C2E82",
  opacity: 0.45,
  style: {
    fill: "rgb(92, 46, 130)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.45,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 360,
  cy: 370,
  r: 8,
  fill: "#FFFFFF",
  opacity: 0.6,
  style: {
    fill: "rgb(255, 255, 255)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.6,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 382,
  cy: 340,
  r: 5,
  fill: "#FFFFFF",
  opacity: 0.5,
  style: {
    fill: "rgb(255, 255, 255)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 395,
  cy: 310,
  r: 4,
  fill: "#FFFFFF",
  opacity: 0.4,
  style: {
    fill: "rgb(255, 255, 255)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.4,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M298,230 L298,340 L222,482 Q218,494 230,502 L450,502 Q462,494 458,482 L382,340 L382,230",
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 4,
  strokeLinejoin: "round",
  opacity: 0.7,
  style: {
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    opacity: 0.7,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 310,
  cy: 200,
  rx: 140,
  ry: 80,
  fill: "url(#glossTop)",
  opacity: 0.25,
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.25,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 280,
  cy: 180,
  rx: 40,
  ry: 18,
  fill: "#FFFFFF",
  opacity: 0.12,
  transform: "rotate(-15,280,180)",
  style: {
    fill: "rgb(255, 255, 255)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.12,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBadgeBetaTester);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/badgeBetaTester.bdfd81099aa058056f04ee56f7414896.svg";